import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ customItems = null }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const routeMap = {
    '/user-dashboard': { label: 'Dashboard', icon: 'LayoutDashboard' },
    '/credit-creation': { label: 'Create Credits', icon: 'Plus' },
    '/project-management': { label: 'Projects', icon: 'FolderOpen' },
    '/video-rendering': { label: 'Video Rendering', icon: 'Play' },
    '/account-settings': { label: 'Account Settings', icon: 'Settings' },
    '/admin-dashboard': { label: 'Admin Dashboard', icon: 'Shield' },
    '/user-management': { label: 'User Management', icon: 'Users' },
    '/user-registration': { label: 'Registration', icon: 'UserPlus' },
    '/user-login': { label: 'Login', icon: 'LogIn' },
  };

  const generateBreadcrumbs = () => {
    if (customItems) return customItems;

    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [{ label: 'Home', path: '/user-dashboard', icon: 'Home' }];

    if (location?.pathname !== '/user-dashboard') {
      const currentRoute = routeMap?.[location?.pathname];
      if (currentRoute) {
        breadcrumbs?.push({
          label: currentRoute?.label,
          path: location?.pathname,
          icon: currentRoute?.icon,
          isActive: true
        });
      }
    } else {
      breadcrumbs[0].isActive = true;
    }

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length <= 1 && !customItems) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {breadcrumbs?.map((item, index) => (
          <li key={index} className="flex items-center space-x-2">
            {index > 0 && (
              <Icon name="ChevronRight" size={14} className="text-border" />
            )}
            
            {item?.isActive ? (
              <span className="flex items-center space-x-1 text-foreground font-medium">
                {item?.icon && <Icon name={item?.icon} size={14} />}
                <span>{item?.label}</span>
              </span>
            ) : (
              <button
                onClick={() => navigate(item?.path)}
                className="flex items-center space-x-1 hover:text-foreground transition-micro"
              >
                {item?.icon && <Icon name={item?.icon} size={14} />}
                <span>{item?.label}</span>
              </button>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;